import { render, staticRenderFns } from "./BCDRights.vue?vue&type=template&id=78796dd1"
import script from "./BCDRights.vue?vue&type=script&lang=js"
export * from "./BCDRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports